import React, { Component } from 'react';

class JobCalendarData extends Component {
    render() {
        let job = this.props.job;
        let worker;
        if (job.team_members.length > 0) {
            worker = job.team_members.map((member) => {
                return (
                    <p className="mb-1" key={member.id}>
                        <b>Team member:</b> {member.first_name + ' ' + member.last_name}
                    </p>
                );
            });
        }
        return (
            <div className="col-md-4 mt-4">
                <div>
                    <p className="mb-1">
                        <b>Id:</b> {job.id}
                    </p>
                    <p className="mb-1">
                        <b>Job Type: </b> {job.display_job_type_name || job.job_type.name}
                    </p>
                    <p className="mb-1">
                        <b>Customer: </b> {job.customer.name}
                    </p>
                    <p className="mb-1">
                        <b>Address: </b> {job.address_line_1}
                    </p>
                    <p className="mb-1">
                        <b>Postcode:</b> {job.postcode}
                    </p>
                    {worker}
                </div>
            </div>
        );
    }
}

export default JobCalendarData;
